import {
  HomePageToolkit,
  HomePageStarredEntities,
  HomePageRecentlyVisited,
  HomePageCompanyLogo
} from '@backstage/plugin-home';

import { Content, Page } from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { Avatar, Button, Grid, Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import CategoryIcon from '@material-ui/icons/Category';
import RadarIcon from '@material-ui/icons/Security';
import SideDrawer from '@internal/plugin-service/src/components/atoms/sideDrawer';
import ChatAi from '../Aiden/MainContent';
import aiden from '../Aiden/MainContent/Deck/aiden.png';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import './homepageStyles.css';

export default {
  title: 'Plugins/Home/Templates',
  decorators: [],
};

const getIcon = (iconText: string) => {
  switch(iconText) {
    case 'CategoryIcon': return <CategoryIcon fontSize='large'/>;
    case 'GrafanaLogo': return <GrafanaLogo />;
    case 'OpsVerseLogo': return <OpsVerseLogo />;
    case 'ArgoCDLogo': return <ArgoCDLogo />;
    case 'AtlassianLogo': return <AtlassianLogo />;
    case 'GithubLogo': return <GithubLogo />;
    case 'SonarQubeLogo': return <RadarIcon fontSize='large'/>;
    case 'AidenLogo': return <AidenLogo />;
    default: return <CategoryIcon fontSize='large'/>;
  }
}

export const HomePage = () => {
  const [showAiBot, setShowAiBot] = useState(false);
  const config = useApi(configApiRef);
  const splashImage = config.getString('customerCustomizations.splash');
  const toolList = config.getConfigArray('customerCustomizations.tools');
  const enableAiden = config.getBoolean('customerCustomizations.aiden.enable');

  const toolkitItems = [];
  for(let tool of toolList) {
    toolkitItems.push({ url: tool.getString('url'), label: tool.getString('label'), icon: getIcon(tool.getString('icon'))});
  }

  return (
    <Page themeId="home">
      <Content>
        <Grid container justifyContent="center" spacing={6}>
        <Grid container item xs={12} justifyContent="center" alignItems="center" direction="row">
            <HomePageCompanyLogo logo={ <HomePageLogo splashImage={splashImage} />} />
          </Grid>
          <Grid container item xs={6} md={6} alignItems="center" direction="row">
            <HomePageSearchBar
              style={{ display: 'flex', backgroundColor: "#FFF", margin: 'auto' }}
              placeholder="Search"
            />
          </Grid>
          <Grid container item xs={12}>
            <Grid item xs={12} md={6}>
              <HomePageStarredEntities />
              <br/>
              <HomePageRecentlyVisited />
            </Grid>
            <Grid item xs={12} md={6} className='toolkit'>
              <HomePageToolkit
                tools={toolkitItems}
              />
            </Grid>
          </Grid>
        </Grid>
        <div
          style={{
            position: 'relative',
            height: '100vh',
            width: '100vw',
            padding: '50px',
          }}
        >
          { enableAiden && <Tooltip title="Aiden">
            <Button
              variant="contained"
              onClick={() => setShowAiBot(true)}
              style={{
                position: 'fixed',
                bottom: 50,
                right: 50,
                backgroundColor: 'white',
                height: '5rem',
                width: '5rem',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
              }}
              className="circle-wrapper"
            >
              <Avatar
                src={aiden}
                alt="Aiden Avatar"
                style={{
                  width: '60%',
                  height: '60%',
                  borderRadius: '50%',
                }}
              />
              <div className='success circle'></div>
            </Button>
          </Tooltip> }
        </div>
        <SideDrawer
          width="50vw"
          open={showAiBot}
          close={() => setShowAiBot(false)}
        >
          <ChatAi/>
        </SideDrawer>
      </Content>
    </Page>
  );
};

const GrafanaLogo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="3 8 52 45" xmlns="http://www.w3.org/2000/svg" width={45} height={45} {...props}>
    <defs>
      <clipPath id="a">
        <path d="m10.793 2.738-.02.094-.3.09c-.137.043-.274.094-.414.144a9.042 9.042 0 0 0-1.215.563c-.254.14-.508.3-.75.473-.035-.02-.063-.032-.063-.032-2.5-.953-4.719.196-4.719.196-.199 2.656 1 4.332 1.239 4.636-.063.16-.117.328-.168.496a11.658 11.658 0 0 0-.442 2.137C1.633 12.675.95 15.012.95 15.012c1.926 2.215 4.172 2.351 4.172 2.351.004 0 .004-.004.008-.004.285.508.613.996.988 1.446.156.191.32.375.488.55-.703 2.008.098 3.68.098 3.68 2.145.082 3.555-.937 3.852-1.172a9.699 9.699 0 0 0 2.656.488c.168.008.336.012.504.012h.137l.105-.004.105-.007v.003c1.012 1.442 2.79 1.645 2.79 1.645 1.261-1.332 1.335-2.652 1.335-2.938v-.059c-.003-.023-.003-.042-.003-.062.261-.187.515-.386.757-.601a7.94 7.94 0 0 0 1.313-1.54c.035-.054.07-.105.101-.16 1.43.083 2.438-.886 2.438-.886-.234-1.492-1.086-2.219-1.262-2.356 0 0-.008-.003-.02-.011-.007-.008-.015-.012-.015-.012a.085.085 0 0 0-.031-.02c.008-.093.015-.18.02-.27a6.65 6.65 0 0 0 .015-.48v-.21c0-.04-.004-.024-.004-.04l-.004-.101-.008-.137c0-.047-.004-.086-.007-.129l-.012-.12-.031-.25a5.048 5.048 0 0 0-.094-.485 6.168 6.168 0 0 0-3.469-4.227 5.896 5.896 0 0 0-2.543-.523H15.2a.419.419 0 0 0-.039.004h-.043l-.105.008-.114.011a4.813 4.813 0 0 0-2.004.652 4.74 4.74 0 0 0-1.984 2.332c-.18.462-.277.934-.305 1.391-.007.114-.011.23-.007.344 0 .027 0 .055.004.082v.094c.003.054.011.11.015.164.024.23.067.453.13.668a3.516 3.516 0 0 0 1.422 1.969c.308.214.643.367.972.464.332.098.66.141.972.137h.114c.023 0 .043-.004.062-.004.02 0 .043-.004.063-.004.03-.004.066-.004.097-.008l.028-.003.03-.004a.301.301 0 0 1 .06-.008c.042-.008.078-.016.113-.02l.11-.023c.07-.016.136-.04.206-.059a2.713 2.713 0 0 0 .707-.36c.031-.019.059-.042.086-.062a.253.253 0 0 0 .04-.351.247.247 0 0 0-.313-.059c-.024.016-.051.028-.079.04a1.68 1.68 0 0 1-.285.117 2.546 2.546 0 0 1-.308.078c-.055.007-.11.015-.164.02a.639.639 0 0 1-.086.007c-.028 0-.059.004-.082 0h-.082c-.035 0-.067-.004-.102-.004 0 0-.015 0-.004-.004h-.011l-.02-.004c-.016 0-.031 0-.047-.004a2.793 2.793 0 0 1-.816-.223 2.771 2.771 0 0 1-.668-.437 2.619 2.619 0 0 1-.524-.656 2.552 2.552 0 0 1-.312-1.266c.004-.039.004-.078.008-.12v-.009l.004-.011v-.032c.003-.02.003-.039.007-.058.008-.082.02-.16.035-.238.11-.637.43-1.258.922-1.727.121-.117.254-.227.395-.324a3.165 3.165 0 0 1 .937-.434c.168-.043.34-.074.516-.09.086-.004.172-.007.262-.007h.058l.07.003H15.212l.07.008a3.958 3.958 0 0 1 1.637.489 3.92 3.92 0 0 1 1.602 1.664 3.747 3.747 0 0 1 .398 1.414l.008.074.004.074v.074c0 .028.004.055.004.07v.067l-.004.07c0 .047-.004.125-.008.176-.008.106-.016.215-.031.32-.012.11-.032.215-.051.32-.02.106-.043.212-.07.313-.051.207-.118.414-.196.614a5.32 5.32 0 0 1-.625 1.128 5.08 5.08 0 0 1-1.996 1.633 5.102 5.102 0 0 1-1.887.446h-.074l-.07.003h-.16c.027 0-.008 0-.004-.003h-.024a6.485 6.485 0 0 1-1.715-.266 6.901 6.901 0 0 1-1.285-.516 6.86 6.86 0 0 1-2.117-1.754 6.846 6.846 0 0 1-1.234-2.418 6.99 6.99 0 0 1-.223-1.328l-.004-.086v-.039l-.004-.035v-.074l-.004-.02v-.25c0-.054.004-.109.004-.164A8.004 8.004 0 0 1 7.32 11c.047-.227.102-.453.168-.676a8.52 8.52 0 0 1 .469-1.273 7.035 7.035 0 0 1 1.457-2.102c.149-.144.3-.281.461-.41a6.296 6.296 0 0 1 1.29-.797c.042-.02.089-.043.136-.062l.14-.059c.188-.078.38-.144.57-.207l.15-.047c.046-.015.097-.027.144-.039.097-.027.199-.05.297-.078.05-.012.101-.02.148-.031.05-.012.102-.024.152-.032.051-.011.102-.019.153-.027l.074-.015.074-.012.152-.024c.06-.007.118-.011.172-.02.047-.007.125-.015.172-.023.035-.003.07-.007.106-.007l.105-.012.043-.004.172-.012.086-.004h.004l.02-.004h.035c.05-.003.097-.003.148-.007.195-.004.387-.004.578 0a7.834 7.834 0 0 1 3.176.805 8.27 8.27 0 0 1 1.676 1.093c.027.024.058.05.09.074a94.043 94.043 0 0 0 .258.238c.058.051.113.106.167.16.051.055.106.106.16.16.204.22.395.442.57.665.345.445.622.894.84 1.316.016.028.028.055.044.082l.035.079c.027.05.054.101.078.156l.07.152c.02.05.043.102.063.149.082.199.16.386.218.566.102.289.176.547.235.773.023.09.11.153.199.145a.19.19 0 0 0 .172-.188 8.138 8.138 0 0 0-.27-2.234 8.804 8.804 0 0 0-1.781-3.422 8.43 8.43 0 0 0-.629-.676c.34-1.343-.41-2.507-.41-2.507-1.289-.079-2.113.402-2.418.62-.05-.019-.102-.042-.152-.062a9.983 9.983 0 0 0-1.39-.445 9.553 9.553 0 0 0-.743-.14c-.047-.009-.09-.016-.133-.02C14.56.754 12.941 0 12.941 0c-1.804 1.137-2.148 2.738-2.148 2.738"/>
      </clipPath>
      <linearGradient id="b" x1="-819.765" x2="-812.649" y1="8201.71" y2="8201.71" gradientTransform="matrix(0 -3.08177 -3.08177 0 25287.794 -2496.93)" gradientUnits="userSpaceOnUse">
        <stop offset="0" style={{ stopColor: "rgb(255, 242, 0)", stopOpacity: 1 }} />
        <stop offset="1" style={{ stopColor: "rgb(241, 90, 41)", stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <g clipPath="url(#a)" transform="matrix(2.104556083679199, 0, 0, 2.104556083679199, 3.812613010406494, 5.420511245727539)">
      <path d="M.95-.004h22.1V24H.95Zm0 0" style={{ stroke: "none", fillRule: "nonzero", fill: "url('#b')" }}/>
    </g>
  </svg>
)

const AtlassianLogo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={45} height={45} {...props}>
    <path
      d="M23.043 9.168c.11.102.18.23.242.36l.024.046c.023.051.05.102.074.149.02.039.035.074.055.109l.117.238c.058.117.12.235.18.356.1.199.199.402.3.605.102.203.203.406.309.61.004.015.011.027.02.039.03.066.062.133.097.199l.715 1.43c.234.472.472.945.707 1.414l.023.047c.067.132.133.265.2.402.167.332.331.664.5.996l.023.047c.367.738.738 1.476 1.105 2.215l1.54 3.074c.015.035.03.066.046.098.078.16.16.316.239.476l.023.047c.04.078.078.16.117.238a4258394.579 4258394.579 0 0 0 1.602 3.2l.023.046c.102.203.207.41.309.618.316.636.637 1.273.953 1.906.027.055.05.105.078.16.008.012.016.023.02.039l.304.61c.102.199.203.402.301.601l.176.352.117.234c.023.047.047.09.066.133.102.199.2.394.293.597.043.086.086.176.13.262a.636.636 0 0 0 .023.05l.07.134.07.144c.043.086.086.168.125.25l.2.399.035.066c.015.035.035.07.05.102.063.129.13.257.192.386.008.012.012.024.02.035.093.192.19.38.285.57.097.196.195.391.297.587.058.12.117.242.18.363.042.082.081.164.124.246.024.047.047.094.07.145.028.05.051.101.079.152l.023.047c.063.133.11.266.11.414-.004.016-.004.016-.004.031a.82.82 0 0 1-.227.54c-.129.116-.313.218-.492.218-.012.004-.028.004-.04.004H29.883c-.487.004-.972.004-1.46.004h-2.25c-.293 0-.524-.02-.75-.227-.16-.176-.258-.43-.363-.644-.02-.035-.036-.075-.055-.11-.043-.082-.082-.164-.121-.246-.063-.117-.121-.238-.18-.36-.117-.226-.23-.456-.344-.683a33.306 33.306 0 0 0-.265-.527l-.035-.074L24 33.02c-.176-.356-.355-.708-.531-1.063-.012-.02-.012-.02-.02-.043a3.28 3.28 0 0 1-.101-.203c-.008-.012-.016-.023-.024-.04a.78.78 0 0 0-.039-.081c-.21-.422-.422-.844-.633-1.27-.238-.472-.476-.949-.715-1.425-.023-.051-.05-.102-.074-.153-.008-.012-.015-.023-.02-.035a25.556 25.556 0 0 0-.284-.566c-.106-.215-.211-.43-.32-.641l-.165-.328c-.422-.848-.422-.848-.586-1.223-.004-.012-.011-.027-.015-.043-.035-.074-.067-.152-.098-.226-.008-.02-.008-.02-.016-.035-.09-.223-.175-.446-.257-.668l-.012-.032c-.438-1.199-.754-2.445-1.024-4.785 0-.031-.003-.062-.007-.094-.028-.363-.028-.726-.028-1.09v-.117c0-.48.016-.957.059-1.437.004-.012.004-.027.004-.043.125-1.379.41-2.742.89-4.149.012-.03.02-.062.032-.09.097-.288.207-.574.324-.855l.012-.031c.152-.36.312-.715.484-1.063.008-.02.016-.035.023-.054.102-.203.211-.407.32-.606.009-.015.016-.031.024-.047.176-.312.356-.62.55-.921.048-.07.09-.141.13-.215.11-.188.281-.29.48-.348a.83.83 0 0 1 .68.168ZM16.98 21.3c.09.079.16.165.235.259.035.043.074.082.11.125.073.078.144.16.21.246a23487.693 23487.693 0 0 0 .164.21c.008.012.02.024.028.036.242.312.464.637.68.969l.023.039c.207.324.394.66.57 1.003.02.036.04.07.059.11.308.574.554 1.187.77 1.805.003.007.007.02.015.03.129.376.242.755.347 1.138l.008.035c.262.972.414 1.976.473 2.98v.047c.07 1.273-.043 2.582-1.074 5.434-.188.199-.414.246-.676.254h-1.043c-.234 0-.473-.004-.707-.004H14.949c-.437-.004-.875-.004-1.312-.004H11.34c-.207 0-.418-.004-.625-.004h-.762c-.285 0-.52-.016-.738-.219a.854.854 0 0 1-.23-.613c.015-.23.136-.43.238-.63.011-.026.027-.054.039-.077l.082-.164c.035-.07.07-.137.101-.207l.082-.16c.012-.024.024-.051.04-.075.062-.129.124-.254.19-.375.11-.21.216-.422.321-.633.031-.062.063-.12.09-.183l.234-.469c.086-.168.168-.336.254-.504l.09-.18c.215-.433.215-.433.313-.613.101-.195.195-.39.293-.586.03-.062.062-.12.093-.183.078-.157.157-.313.23-.465.087-.172.169-.34.255-.508.03-.059.058-.121.09-.18.214-.433.214-.433.312-.613.102-.191.195-.387.293-.578l.09-.184c.078-.152.152-.304.23-.46.082-.165.164-.333.25-.497.028-.058.059-.12.086-.18.215-.425.215-.425.293-.574.11-.203.211-.41.313-.617l.093-.183c.079-.157.157-.313.23-.47.087-.167.169-.335.255-.503.031-.059.058-.121.09-.184.218-.433.218-.433.316-.617.078-.148.149-.293.223-.441l.082-.164.011-.028c.012-.02.02-.039.028-.058.066-.125.129-.254.191-.38l.13-.257c.019-.047.042-.094.066-.137.023-.05.05-.101.074-.152.008-.016.015-.031.023-.043.125-.254.32-.414.582-.512a.803.803 0 0 1 .7.149Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#0052CC",
        fillOpacity: 1,
      }}
    />
  </svg>
)

const GithubLogo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={45} height={40} {...props}>
    <path
      d="M35.281 35.5c0 2.46-5.648 4.453-12.613 4.453S10.055 37.961 10.055 35.5c0-2.457 5.648-4.453 12.613-4.453s12.613 1.996 12.613 4.453Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#9cdaf1",
        fillOpacity: 1,
      }}
    />
    <path
      d="M19.242 39.785v-3.172c0-.41-.074-.754-.199-1.043.816.637.871 2.239.871 2.239v2.039c.73.054 1.488.09 2.262.101l-.02-2.027c-.113-2.77-2.468-3.11-2.468-3.11-.86-.195-.848.239-.758.52-.844-1.45-3.11-1.262-3.11-1.262-.78.282-.054.79-.054.79 1.234.453 1.343 1.812 1.343 1.812V39.5c.68.117 1.391.215 2.133.285ZM29.16 34.07s-2.262-.187-3.105 1.266c.086-.285.101-.719-.762-.523 0 0-2.352.34-2.465 3.109l-.02 2.031a35.382 35.382 0 0 0 2.262-.082V37.81s.055-1.602.867-2.239a2.67 2.67 0 0 0-.195 1.043v3.207c.738-.066 1.45-.152 2.13-.261v-2.891s.112-1.355 1.347-1.809c0 0 .726-.507-.059-.793Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#7dbbe6",
        fillOpacity: 1,
      }}
    />
    <path
      d="m44.926 17.043.035-.164c-3.703-.746-7.5-.754-9.797-.66.379-1.371.492-2.95.492-4.707 0-2.524-.941-4.543-2.465-6.078.266-.872.621-2.797-.355-5.266 0 0-1.727-.555-5.633 2.082a19.846 19.846 0 0 0-4.789-.574c-1.793 0-3.605.23-5.297.699C13.086-.398 11.31.168 11.31.168c-1.16 2.93-.442 5.098-.227 5.637-1.363 1.484-2.195 3.383-2.195 5.707 0 1.754.195 3.332.68 4.699-2.317-.086-5.973-.05-9.544.668l.036.164c3.59-.723 7.27-.746 9.57-.66.11.285.226.558.36.824-2.278.074-6.165.367-9.891 1.426l.047.164c3.753-1.067 7.675-1.352 9.933-1.422 1.36 2.559 4.04 4.207 8.813 4.727-.676.46-1.368 1.242-1.649 2.562-.922.445-3.844 1.531-5.597-1.512 0 0-.98-1.808-2.86-1.949 0 0-1.82-.027-.125 1.145 0 0 1.219.578 2.059 2.757 0 0 1.097 3.711 6.394 2.52v3.836s-.113 1.36-1.347 1.812c0 0-.727.508.058.79 0 0 3.418.285 3.418-2.543v-4.184s-.137-1.66.672-2.234v6.87s-.055 1.637-.894 2.262c0 0-.563 1.016.671.735 0 0 2.352-.34 2.465-3.11l.055-6.953h.562l.055 6.953c.113 2.77 2.469 3.11 2.469 3.11 1.23.281.672-.735.672-.735-.844-.625-.899-2.261-.899-2.261V25.16c.809.633.672 2.176.672 2.176v4.184c0 2.828 3.418 2.543 3.418 2.543.785-.282.059-.79.059-.79-1.235-.453-1.348-1.812-1.348-1.812v-5.48c0-2.141-.89-3.274-1.766-3.872 5.09-.507 7.532-2.164 8.657-4.738 2.23.059 6.242.336 10.078 1.426l.047-.164c-3.817-1.082-7.801-1.363-10.051-1.43.105-.262.2-.531.281-.808 2.285-.098 6.102-.098 9.817.652Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#000",
        fillOpacity: 1,
      }}
    />
    <path
      d="M30.68 11.395c1.097 1 1.738 2.21 1.738 3.511 0 6.086-4.496 6.25-10.043 6.25-5.547 0-10.043-.843-10.043-6.25 0-1.293.629-2.496 1.711-3.492 1.809-1.664 4.863-.781 8.332-.781 3.45-.004 6.496-.89 8.305.758Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#f4cbb2",
        fillOpacity: 1,
      }}
    />
    <path
      d="M19.031 15.215c0 1.68-.933 3.035-2.09 3.035-1.152 0-2.086-1.355-2.086-3.035 0-1.672.934-3.031 2.086-3.031 1.157 0 2.09 1.359 2.09 3.03Zm11.215 0c0 1.68-.937 3.035-2.09 3.035-1.156 0-2.09-1.355-2.09-3.035 0-1.672.934-3.031 2.09-3.031 1.153 0 2.09 1.359 2.09 3.03Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fff",
        fillOpacity: 1,
      }}
    />
    <path
      d="M18.363 15.254c0 1.117-.625 2.023-1.394 2.023-.766 0-1.39-.906-1.39-2.023s.62-2.024 1.39-2.024c.77 0 1.394.907 1.394 2.024Zm11.211 0c0 1.117-.625 2.023-1.394 2.023-.766 0-1.39-.906-1.39-2.023s.62-2.024 1.39-2.024c.77 0 1.394.907 1.394 2.024ZM22.926 17.91a.521.521 0 1 1-1.043 0c0-.289.234-.527.523-.527.29 0 .52.238.52.527ZM21.188 19.246a.17.17 0 0 1 .101-.219.169.169 0 0 1 .215.106.95.95 0 0 0 .894.64.958.958 0 0 0 .899-.64.163.163 0 0 1 .21-.106c.09.032.138.13.106.22a1.296 1.296 0 0 1-1.215.862 1.282 1.282 0 0 1-1.21-.863Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#ad5c51",
        fillOpacity: 1,
      }}
    />
    <path
      d="M9.598 21.656c0 .14-.164.254-.364.254-.203 0-.363-.113-.363-.254 0-.14.16-.258.363-.258.2 0 .364.118.364.258Zm1.011.563c0 .14-.164.254-.367.254-.199 0-.363-.114-.363-.254s.164-.254.363-.254c.203 0 .367.113.367.258Zm.614.738c0 .14-.16.254-.364.254-.199 0-.363-.113-.363-.254 0-.14.164-.258.363-.258.204 0 .364.117.364.258Zm.562.848c0 .14-.164.254-.363.254-.203 0-.367-.114-.367-.254s.164-.254.367-.254c.2 0 .363.113.363.254Zm.617.789c0 .14-.164.254-.367.254-.2 0-.363-.114-.363-.254s.164-.254.363-.254c.203 0 .367.113.367.254Zm.84.68c0 .14-.164.253-.363.253-.203 0-.367-.113-.367-.254 0-.14.164-.253.367-.253.2 0 .363.113.363.253Zm1.176.453c0 .14-.164.253-.363.253-.2 0-.364-.113-.364-.253 0-.141.164-.254.364-.254.199 0 .363.113.363.254Zm1.172 0c0 .14-.16.253-.363.253-.2 0-.364-.113-.364-.253 0-.141.164-.254.364-.254.203 0 .363.113.363.254Zm1.191-.196c0 .14-.164.254-.367.254-.2 0-.363-.113-.363-.254 0-.144.164-.258.363-.258.203 0 .367.114.367.258Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#c3e4d8",
        fillOpacity: 1,
      }}
    />
    <path
      d="m8.262 22.41-.367 1.277s-.094.465.34.547c.449-.011.413-.433.382-.574Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#9cdaf1",
        fillOpacity: 1,
      }}
    />
  </svg>
)
const ArgoCDLogo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 10 54 42" width="45" height="45"  {...props}>
    <path
      d="M24.495 49.214s.009.009.009.036l.01.616.09-.471c-.019-.29-.255-.136-.109-.172v-.009Zm12.56-16.383s-.009 0-.018.009c.009 0 .018.009.018.019v-.028Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fefefe",
        fillOpacity: 1,
        transformOrigin: "30.7513px 41.3485px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="m35.888 53.098.117-2.094c.192-1.52.011-3.07.41-4.565.199-.776-.436-1.692.371-2.372l-.2-.66c-.227-.371-.109-.735.028-1.097-.018-1.33 0-2.661.234-3.985l.218-5.494s-.009-.011-.018-.011c-3.911 1.793-7.598-.724-8.224-3.74-.417-1.982-.189-3.858 1.35-5.369.262-.255.48-.545.725-.826.634-3.786.172-7.262-3.053-9.969.49-.282.925-.127 1.305-.192-3.957-1.005-8.774 1.713-10.369 5.861-.48 1.25-.742 2.527-.661 3.866 3.941-1.83 7.481.354 8.439 3.678 1.006 3.449-1.683 7.108-5.261 7.154a10.079 10.079 0 0 1-3.025-.445l.228 5.715c.136 1.252.28 2.498.226 3.757l.026.888-.026.598c.29 1.195.353 2.428.443 3.65a.334.334 0 0 1-.018-.091c0 .037.009.063.018.081l.299 6.26c.063.858-.243 1.293-1.042 1.511-.94.262-1.865.58-2.787.879 1.224.152 2.46.206 3.693.162 1.321-.028 1.928-.608 2.056-1.938l.236-2.509.256-4.564h.188v4.338l.071 1.974c.191 3.061.29 3.033-2.761 3.65-.072.018-.137.053-.199.081l.542.37c.058.01.106.043.137.093.723 0 1.458.063 2.172 0 1.315-.127 1.929-.825 2.028-2.121.056-.842.14-1.664.209-2.499-.109-1.113.056-2.201.265-3.287l-.019-.605c0-.028-.009-.046-.009-.046-.137.037.09-.11.115.18l.075-.389v5.016l.046 1.767c.026 2.128-.109 2.318-2.138 2.935-.562.162-1.151.252-1.703.452-.399.135-.913.062-1.294.533 1.655-.062 3.197.127 4.736-.126 1.593-.254 2.226-.897 2.553-2.445.237-1.132.345-2.319.77-3.477.062.115.115.171.127.243l.651 3.243c.299 1.502.916 2.147 2.435 2.418 1.586.271 3.19.082 4.838.116-.236-.397-.607-.333-.905-.415-1.015-.299-2.058-.552-3.062-.897-.725-.255-1.252-.714-1.24-1.611l.009-7.363h.299l.306 4.609c.191 3.561.617 3.941 4.185 3.75.199-.336.689-.074.878-.435-.86 0-1.601-.417-2.39-.679-.444-.144-.688-.543-.679-1.044.035-2.515-.055-5.051.278-7.558l.536 6.33c.074.985.517 1.757 1.567 1.82 1.386.09 2.798.027 4.203.027-.742-.37-1.504-.589-2.265-.835-1.71-.551-1.701-.551-1.539-2.299l-.01.047ZM25.104 17.164a1.286 1.286 0 0 1-1.268 1.266c-.751.018-1.322-.417-1.34-1.394.09-.707.48-1.187 1.322-1.215.896-.006 1.305.598 1.286 1.343Zm5.758 20.945c0 1.939-1.477 3.631-3.177 3.622-1.596 0-3.235-1.892-3.17-3.677l-.301-1.792c1.143.779 2.102 1.583 3.398 1.611 1.313.019 2.344-.652 3.422-1.439.237.626-.343 1.121-.172 1.675Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fe733e",
        fillOpacity: 1,
        transformOrigin: "27.6715px 36.1019px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="m18.776 42.31-.271-.11c-1.305-.533-2.458-1.358-3.505-2.272-3.802-3.287-6.313-7.399-6.921-12.397-.685-5.668.58-10.904 4.366-15.394 3.452-4.104 7.852-6.494 13.105-7.048 5.843-.605 11.082 1.025 15.503 5.054 3.686 3.369 5.824 7.535 6.385 12.433.47 4.175-.281 8.207-2.427 11.865-1.948 3.331-4.545 6.03-8.06 7.743l-.289.144c-.128.362-.255.726-.019 1.096.082-.074.153-.161.244-.217 5.309-2.808 8.984-6.974 10.703-12.779.147-.498.381-.742.925-.679.752.072.961-.424.961-1.05l.009-7.163c0-.515-.128-1.079-.662-1.132-.978-.116-1.096-.835-1.295-1.521-1.159-4.047-3.362-7.418-6.665-9.999-6.756-5.306-14.165-6.257-21.943-2.68-5.777 2.662-9.454 7.273-11.121 13.446-.109.383-.062.844-.714.7-.925-.189-1.277.353-1.277 1.176l-.009 7.164c0 .797.408 1.224 1.168 1.031.695-.171.869.174 1.013.719a19.212 19.212 0 0 0 3.072 6.292c2.063 2.788 4.572 5.035 7.759 6.456l-.035-.897v.019Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#b5d2f3",
        fillOpacity: 1,
        transformOrigin: "27.642px 23.749px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M18.702 43.745c-.716 1.993-2.599 1.937-4.203 2.434 1.206.317 2.434.672 3.64.473.717-.128.853.127.96.552l.028.109.019.08c-.093-1.23-.154-2.452-.444-3.648Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fe684b",
        fillOpacity: 1,
        transformOrigin: "16.8225px 45.569px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M36.38 46.48c1.53.697 2.979 0 4.453-.209-1.437-.605-3.315-.297-4.073-2.156-.817.682-.174 1.586-.38 2.365Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fe6446",
        fillOpacity: 1,
        transformOrigin: "38.5826px 45.4488px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="m24.647 48.971-.082.39-.093.463c-.208 1.085-.371 2.172-.253 3.285.355.181.082.68.437.881v-5.021l-.009.002Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fed6c8",
        fillOpacity: 1,
        transformOrigin: "24.4176px 51.4795px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="m21.837 47.214-.254 4.556.445-.228v-4.328h-.191Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#feebe3",
        fillOpacity: 1,
        transformOrigin: "21.8055px 49.492px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M17.307 57.705h2.472l-.679-.451c-.543-.028-1.051.093-1.793.451Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fe9166",
        fillOpacity: 1,
        transformOrigin: "18.543px 57.4776px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M35.228 57.774h2.411c-.492-.278-.972-.514-1.523-.424-.191.362-.689.082-.888.424Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fe8f64",
        fillOpacity: 1,
        transformOrigin: "36.4335px 57.5523px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M36.951 42.175c3.513-1.704 6.102-4.412 8.06-7.743 2.146-3.667 2.897-7.697 2.427-11.872-.552-4.901-2.699-9.065-6.385-12.417-4.41-4.038-9.663-5.677-15.484-5.061-5.251.543-9.663 2.945-13.112 7.046-3.798 4.49-5.063 9.725-4.378 15.403.608 4.99 3.126 9.101 6.921 12.388 1.059.914 2.2 1.739 3.503 2.272.093.037.174.074.282.11.063-1.26-.092-2.5-.226-3.756l-.29-.202c-.97-.695-1.802-1.577-2.643-2.427-.255-.262-.573-.481-.573-.895-.561.398-.969.115-1.303-.327-1.838-2.518-2.953-5.297-3.097-8.439-.137-2.763.116-5.462 1.275-8.051 1.486-3.288 3.761-5.805 6.811-7.671.517-.318.817-.035 1.178.199.345-.016.668-.179.888-.442l-.046-.101c-.309-.644-.318-1.376.417-1.548.742-.181 1.168.434 1.168 1.205 5.541-1.813 10.694-1.07 15.347 2.481 3.478 2.652 5.471 6.201 6.088 10.548.788 5.581-1.105 10.207-4.988 14.119-.465.463-.979.88-1.568 1.187a4.12 4.12 0 0 1-.301.143c-.233 1.322-.253 2.655-.233 3.987l.27-.145-.008.009Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#e2f5fc",
        fillOpacity: 1,
        transformOrigin: "27.737px 23.6336px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M38.781 37.004c3.883-3.911 5.768-8.538 4.988-14.119-.607-4.335-2.598-7.905-6.085-10.548-4.646-3.56-9.806-4.284-15.34-2.474-.009 0-.019.019-.028.019-.433.28-.769.879-1.403.508-.037-.028-.074-.046-.108-.074-.22.263-.543.424-.888.435l-.056.172c-.396 1.113-1.583 1.405-2.387 2.085-2.166 1.819-3.78 4-4.73 6.627-1.52 4.238-1.212 8.394.835 12.415.324.653.732 1.268 1.166 1.856.244.315.355.716.308 1.113 0 .436.318.663.571.916.843.851 1.675 1.72 2.643 2.427l.292.209-.228-5.723c-1.664-1.097-2.879-2.482-3.088-4.545-.262-2.554.807-4.449 2.898-5.816l.028-.026a9.041 9.041 0 0 1 .651-3.858c1.596-4.157 6.413-6.874 10.379-5.879 2.652.427 4.818 1.632 6.367 3.842 1.24 1.764 1.882 3.711 1.739 5.885 1.492 1.141 2.698 2.472 2.897 4.438.262 2.652-.869 4.581-3.097 5.931v.028l-.218 5.496c.1-.047.209-.09.301-.144a6.724 6.724 0 0 0 1.575-1.196h.018Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#cdecf6",
        fillOpacity: 1,
        transformOrigin: "27.866px 23.7388px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M32.338 22.262c1.656-.816 3.241-.38 4.827.144l.181.055c.126-2.174-.51-4.129-1.739-5.888-1.557-2.207-3.723-3.413-6.356-3.836-.408.081-.844-.084-1.322.189 3.232 2.716 3.684 6.192 3.042 9.978l1.384-.642h-.017Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fe6b3c",
        fillOpacity: 1,
        transformOrigin: "32.6454px 17.8205px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M40.206 26.915c-.2-1.976-1.405-3.306-2.898-4.438l-.173-.055c-1.594-.524-3.188-.961-4.827-.154l-1.076.524-.301.139-.715.824c-1.557 1.511-1.765 3.385-1.358 5.369.626 3.025 4.319 5.54 8.23 3.749.012-.01.021-.01.021-.01 2.225-1.359 3.359-3.306 3.097-5.939v-.009Zm-5.861 5.288a4.492 4.492 0 0 1-4.499-4.591 4.542 4.542 0 0 1 4.609-4.493c2.554.019 4.502 2.029 4.483 4.61-.018 2.554-2.019 4.502-4.59 4.474h-.003Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fe6142",
        fillOpacity: 1,
        transformOrigin: "34.46px 27.6472px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M18.119 22.434c-2.082 1.375-3.16 3.268-2.898 5.814.218 2.073 1.432 3.46 3.087 4.544.998.301 1.985.473 3.035.464 3.558-.056 6.267-3.705 5.263-7.163-.962-3.315-4.512-5.498-8.441-3.678-.018.009-.028.019-.037.028l-.009-.009Zm2.862 9.716c-2.619.009-4.636-1.993-4.627-4.59.01-2.546 1.991-4.52 4.553-4.537 2.593-.01 4.665 2.028 4.656 4.572a4.593 4.593 0 0 1-4.582 4.555Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fe6143",
        fillOpacity: 1,
        transformOrigin: "20.9998px 27.506px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M25.099 38.48c-.173-.171-.308-.417-.598-.417-.065 1.776 1.568 3.668 3.17 3.668 1.701.009 3.187-1.683 3.178-3.622-.642.325-1.05 1.005-1.785 1.213-1.474.399-2.824.299-3.965-.842Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#070909",
        fillOpacity: 1,
        transformOrigin: "27.6741px 39.897px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M31.037 36.434c-1.087.778-2.11 1.467-3.431 1.439-1.296-.028-2.265-.834-3.396-1.611l.299 1.801c.289.009.433.246.598.417 1.14 1.132 2.49 1.241 3.964.842.735-.199 1.143-.879 1.785-1.213-.172-.554.408-1.042.181-1.675Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fdfcfb",
        fillOpacity: 1,
        transformOrigin: "27.6502px 37.8973px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M23.901 15.816c-.851.018-1.252.498-1.322 1.214.009.978.58 1.403 1.331 1.394a1.287 1.287 0 0 0 1.268-1.276c.019-.753-.389-1.348-1.277-1.332Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fea777",
        fillOpacity: 1,
        transformOrigin: "23.8788px 17.1199px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M15.048 34.965a1.572 1.572 0 0 0-.308-1.125 13.773 13.773 0 0 1-1.166-1.854c-2.04-4.011-2.346-8.171-.835-12.417.96-2.636 2.564-4.808 4.73-6.619.804-.672 1.991-.96 2.388-2.093.019-.047.046-.109.056-.163-.363-.236-.653-.516-1.169-.199-3.061 1.866-5.332 4.381-6.818 7.671-1.159 2.59-1.414 5.279-1.278 8.05.153 3.124 1.269 5.913 3.098 8.431.333.452.741.732 1.302.324v-.006Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fdfefe",
        fillOpacity: 1,
        transformOrigin: "15.2639px 22.761px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M22.361 9.858s.018-.019.028-.019c-.01-.779-.436-1.386-1.168-1.205-.733.173-.726.906-.418 1.551l.037.097a.554.554 0 0 0 .117.074c.626.381.962-.227 1.404-.498Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fbfdfe",
        fillOpacity: 1,
        transformOrigin: "21.4975px 9.53995px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M38.938 27.703c.019-2.571-1.929-4.581-4.474-4.599a4.537 4.537 0 0 0-4.618 4.483 4.535 4.535 0 0 0 1.286 3.241 4.498 4.498 0 0 0 3.213 1.358c2.583.019 4.575-1.928 4.591-4.483h.002Zm-4.365.498c-.861.019-1.368-.471-1.44-1.322a1.396 1.396 0 0 1 1.421-1.476c.842.065 1.314.561 1.415 1.439-.11.789-.518 1.35-1.387 1.359h-.009Zm-13.667-5.144c-2.562.019-4.543 1.993-4.552 4.539a4.52 4.52 0 0 0 4.617 4.59 4.599 4.599 0 0 0 4.591-4.543c0-2.555-2.063-4.593-4.656-4.584v-.002Zm.009 5.147c-.85.007-1.367-.483-1.43-1.334-.062-.787.652-1.53 1.44-1.458.835.072 1.322.552 1.386 1.43-.1.817-.542 1.35-1.405 1.359l.009.003Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fefefe",
        fillOpacity: 1,
        transformOrigin: "27.6458px 27.6221px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M34.557 25.431c-.789-.055-1.493.678-1.421 1.475.071.851.579 1.34 1.44 1.321.878-.018 1.286-.57 1.395-1.358-.1-.878-.58-1.375-1.423-1.438h.009Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#090b0b",
        fillOpacity: 1,
        transformOrigin: "34.551px 26.8278px",
      }}
      transform="rotate(.215 0 0)"
    />
    <path
      d="M20.928 25.385c-.789-.072-1.502.661-1.437 1.458.062.851.579 1.341 1.427 1.331.861-.009 1.305-.542 1.405-1.359-.081-.878-.57-1.367-1.386-1.43h-.009Zm0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#090c0c",
        fillOpacity: 1,
        transformOrigin: "20.9049px 26.7771px",
      }}
      transform="rotate(.215 0 0)"
    />
  </svg>
)

const OpsVerseLogo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={45} height={45} viewBox={"0 -3 40 45"} version="1.1" {...props}>
    <g id="surface1">
      <path style={{ stroke: "#00A9A5", fillRule:"nonzero",fill:"#00A9A5",fillOpacity:1 }} d="M 7.589844 12.726562 C 19.226562 12.890625 27.539062 25.359375 27.539062 25.359375 C 27.539062 25.359375 29.648438 14.199219 25.636719 6.757812 C 30.9375 9.019531 34.375 14.226562 34.375 19.988281 C 34.375 27.921875 27.9375 34.355469 20 34.355469 C 12.0625 34.355469 5.625 27.921875 5.625 19.988281 C 5.625 17.339844 6.339844 14.855469 7.589844 12.726562 Z M 9.933594 9.726562 C 18.207031 9.316406 24.621094 16.308594 24.621094 16.308594 C 24.621094 16.308594 24.53125 9.753906 19.320312 5.625 C 15.792969 5.789062 12.449219 7.25 9.933594 9.726562 Z M 9.933594 9.726562 "/>
      <path style={{ stroke: "#00A9A5", fillRule:"nonzero",fill:"#00A9A5", fillOpacity:1 }}  d="M 40 20 C 40 31.046875 31.046875 40 20 40 C 8.953125 40 0 31.046875 0 20 C 0 8.953125 8.953125 0 20 0 C 31.046875 0 40 8.953125 40 20 Z M 20 37.589844 C 29.714844 37.589844 37.589844 29.714844 37.589844 20 C 37.589844 10.285156 29.714844 2.410156 20 2.410156 C 10.285156 2.410156 2.410156 10.285156 2.410156 20 C 2.410156 29.714844 10.285156 37.589844 20 37.589844 Z M 20 37.589844 "/>
    </g>
  </svg>
)

const AidenLogo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    width={60}
    height={60}
    {...props}
  >
    <defs>
      <linearGradient id="linear-gradient" x1="20.74" y1="101.33" x2="187" y2="101.33" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#acdd4d"/>
        <stop offset=".43" stopColor="#ccd12e"/>
        <stop offset="1" stopColor="#ffbf00"/>
      </linearGradient>
    </defs>
    <path
      className="st0"
      style={{ fill: "url(#linear-gradient)" }}
      d="M98.51,124.13c-1.33,7.78-1.14,15.41.6,23.05-7.08-3.14-15.86-9.89-17.14-22.84-.41.5-.77.94-1.13,1.37-3.75,4.54-7.94,8.57-13.14,11.42-8.26,4.54-16.88,5.1-25.65,1.85-9.41-3.49-15.84-10.13-19.32-19.51-5.11-13.79-.17-29.6,11.78-37.92,5.94-4.14,12.53-6.09,19.79-5.59,4.2.29,8.2,1.45,12.07,3.1,5.37,2.3,10.2,5.47,14.67,9.2,1.99,1.66,3.98,3.34,5.96,5.01.18.15.37.3.61.5.3-.35.57-.66.83-.98,3.81-4.74,7.52-9.57,11.45-14.2,6.04-7.11,13.02-13.12,21.26-17.62,17.4-9.5,36.36-5.89,49.22,4.86,8.88,7.42,14.32,16.91,16.03,28.33,2.1,13.99-1.43,26.54-10.63,37.33-7.21,8.45-16.42,13.49-27.43,15.14-7.82,1.18-15.34.02-22.62-2.96-6.96-2.84-13.15-6.93-18.83-11.79-2.73-2.34-5.28-4.87-7.92-7.32-.12-.12-.25-.23-.48-.43ZM168.04,101.3c-.05-7.49-2.86-14.18-8.26-19.35-7.14-6.85-18.44-9.78-28.83-4.37-6.62,3.45-12.29,8.03-16.66,14.11-2.76,3.84-5.4,7.76-8.12,11.62-.28.4-.12.61.13.91,3.83,4.59,7.96,8.9,12.56,12.74,4.4,3.68,9.09,6.9,14.46,9,4.13,1.62,8.38,2.27,12.79,1.51,12.75-2.19,22.01-13.24,21.93-26.17ZM34.25,109.52c.31,6.14,3.37,11.86,9.77,15.38,6.16,3.39,12.44,3.34,18.41-.62,1.94-1.29,3.75-2.85,5.41-4.5,4.22-4.2,7.41-9.17,10.25-14.37.2-.36.17-.58-.13-.86-1.48-1.41-2.94-2.83-4.39-4.27-4.05-4.01-8.55-7.33-13.99-9.24-3.54-1.24-7.11-1.92-10.84-1.08-8.55,1.93-14.48,9.5-14.48,19.55Z"
    />
    <path
      d="M113.2,102.6c-.01-6.91,4.08-11.74,10.26-12.8,4.68-.8,8.75.49,11.95,4.01,3.53,3.87,3.76,9.88.72,14.33-3.82,5.59-10.45,7.11-16.74,3.85-4.13-2.14-6.1-5.58-6.19-9.39ZM122.08,99.39c1.97-.01,3.65-1.74,3.64-3.75,0-1.95-1.68-3.55-3.74-3.55-2.18,0-3.85,1.62-3.84,3.75,0,2.04,1.7,3.57,3.94,3.55Z"
      fill="#000"
    />
    <path
      d="M50.64,96.32c3.75.14,7.32,1.75,9.83,5.32,3.02,4.3,2.52,10.41-1.09,14.5-3.83,4.35-9.04,5.45-14.72,3.08-4.54-1.89-7.07-5.27-7.22-10.23-.14-5.02,1.99-8.82,6.5-11.19,1.93-1.01,3.99-1.47,6.7-1.48ZM42.35,102.56c0,2.06,1.66,3.58,3.92,3.59,1.98,0,3.66-1.7,3.67-3.73.01-2-1.66-3.58-3.78-3.57-2.17.01-3.81,1.61-3.81,3.71Z"
      fill="#000"
    />
  </svg>
)

const HomePageLogo = ({ splashImage } : any ) => (
  <img src={'/' + splashImage} width="400px"></img>
)
